import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import './MyOrdersPage.css';
import OrderTile from '../components/OrderTile';
import '../components/OrderTile.css';

export default function MyOrdersPage() {
  const [orders, setOrders] = useState([]);
  const [loading, setLoading] = useState(true);
  const [hasMore, setHasMore] = useState(true);
  const [lastCreatedAt, setLastCreatedAt] = useState(null);
  const [lastId, setLastId] = useState(null);
  const [error, setError] = useState(null);
  const [currentUser, setCurrentUser] = useState(null);
  const pageSize = 10;
  const navigate = useNavigate();

  useEffect(() => {
    const savedUser = localStorage.getItem('user');
    if (savedUser) setCurrentUser(JSON.parse(savedUser));
  }, []);

  const fetchOrders = async () => {
    if (!currentUser) return;
    setLoading(true);
    let url = `https://devbite.vercel.app/api/my_orders?userId=${currentUser.uid}&limit=${pageSize}`;
    if (lastCreatedAt && lastId) {
      url += `&lastCreatedAt=${encodeURIComponent(lastCreatedAt)}&lastId=${encodeURIComponent(lastId)}`;
    }
    try {
      const res = await fetch(url);
      if (!res.ok) throw new Error('Failed to fetch orders');
      const data = await res.json();
      if (data.orders && data.orders.length > 0) {
        setOrders(prev => [...prev, ...data.orders]);
        setLastCreatedAt(data.orders[data.orders.length - 1].createdAt);
        setLastId(data.orders[data.orders.length - 1].id);
        if (data.orders.length < pageSize) setHasMore(false);
      } else {
        setHasMore(false);
      }
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (currentUser) fetchOrders();
    // eslint-disable-next-line
  }, [currentUser]);

  const handleOrderClick = (order) => {
    navigate(`/order/${order.id}`);
  };

  return (
    <div className="my-orders-outer-bg">
      <header className="my-orders-header">
        <button className="my-orders-back" onClick={() => navigate(-1)}>&larr;</button>
        <h1 className="my-orders-title">My Orders</h1>
      </header>
      <div className="my-orders-content">
        {loading && orders.length === 0 && (
          <div className="my-orders-loading"><div className="spinner"></div></div>
        )}
        {error && <div className="my-orders-error">{error}</div>}
        {!loading && orders.length === 0 && <div className="my-orders-empty">No orders found.</div>}
        <div className="my-orders-list">
          {orders.map(order => (
            <OrderTile key={order.id} order={order} onClick={() => handleOrderClick(order)} />
          ))}
        </div>
        {hasMore && !loading && (
          <button className="my-orders-load" onClick={fetchOrders}>Load More</button>
        )}
        {loading && orders.length > 0 && (
          <div className="my-orders-loading"><div className="spinner"></div></div>
        )}
      </div>
    </div>
  );
}
